// extracted by mini-css-extract-plugin
export default {"enter_game":"enter-game_enter_game__00eyy","form_item":"enter-game_form_item__76dcN"};